import React from 'react';

import MainNavbar from 'components/Navbars/MainNavbar';
import MainHeader from 'components/Headers/MainHeader';
import FoodMenu from 'components/Elements/FoodMenu';
import ContactUs from 'components/Elements/ContactUs';

// reactstrap components
// import {
//   Button,
//   Input,
//   Container,
//   Row,
//   Col
// } from 'reactstrap';

function Index(){
  // let pageHeader = React.createRef();

  return (
    <>
      <MainNavbar />
      <div className="wrapper">
        <MainHeader />
        <div className="main">
          <FoodMenu />
          <ContactUs />
        </div>
      </div>
    </>
  );
}

export default Index;